import React from 'react';
import { Box, MessageModalLayout, Text, TextButton } from '@wix/design-system';
import * as panels from '#packages/panels';
import { translate } from '#packages/i18n';

export const MEMBER_AUTH_CUSTOM_FORM_WARNING_MODAL_PANEL_NAME =
  'pageSettingsPanel.modals.memberAuthCustomFormWarningModal';

export interface MemberAuthCustomFormWarningModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
  onLearnMore: () => void;
}

export const MemberAuthCustomFormWarningModal: React.FC<
  MemberAuthCustomFormWarningModalProps
> = ({ onConfirm, onCancel, onClose, onLearnMore }) => (
  <panels.frames.FocusPanelFrame
    shouldHideHeader
    panelName={MEMBER_AUTH_CUSTOM_FORM_WARNING_MODAL_PANEL_NAME}
  >
    <MessageModalLayout
      onCloseButtonClick={onClose}
      primaryButtonText={translate(
        'member_authentication_app_install_app_modal_add',
      )}
      secondaryButtonText={translate(
        'member_authentication_app_install_app_modal_cancel',
      )}
      primaryButtonOnClick={onConfirm}
      secondaryButtonOnClick={onCancel}
      title={translate('member_authentication_app_install_app_modal_title')}
      content={
        <Text>
          {translate('member_authentication_app_install_app_modal_description')}{' '}
          <Box inline>
            <TextButton underline="always" onClick={onLearnMore}>
              {translate(
                'member_authentication_app_install_app_modal_learn_more',
              )}
            </TextButton>
          </Box>
        </Text>
      }
    />
  </panels.frames.FocusPanelFrame>
);
